import React from 'react'
import { Text, Header } from '@crossfit/ui'

import InnerContent from 'components/InnerContent'
import style from './style.module.css'

type Props = {
  subheadlineText?: string
  children: React.ReactNode
}

function PageHeader({ subheadlineText, children }: Props) {
  return (
    <header className={style.header}>
      <InnerContent variant='xlarge' className={style.innerContent}>
        <Header size='large' as='h1' mb={3}>
          {children}
        </Header>
        {subheadlineText && (
          <Text className={style.subheadlineText}>{subheadlineText}</Text>
        )}
      </InnerContent>
    </header>
  )
}

export default PageHeader
